export default "/50f517735fec46580f19aae3e56e9fe21614ea75/d9f26165e744ef064b81249371ce3c44.svg";